/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* plugins/public-seo-badge/assets/js/public-seo-badge.js — badge builder + live preview + embed code. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* If the console does not say 1.0.4, a stale edge copy is being served. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["public-seo-badge"] = "1.0.4"; } catch (e) {}
  var POLL = { interval: 2500, max: 16 };   // ~40s of polling; interval set to 0 in tests
  var SEL = { type: "combined", theme: "light", size: "medium", method: "img" };
  function q(k) { return document.querySelector('[data-sb="' + k + '"]'); }
  function site() { return (window.GS && GS.site) || ""; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function scoreCard(label, v, isStatus) {
    var col = "#9AA7B8", disp = (v == null || v === "unknown") ? "\u2013" : v;
    if (!isStatus && typeof v === "number") col = v >= 90 ? "#0CCE6B" : v >= 50 ? "#FFA400" : "#FF4E42";
    if (isStatus) { col = (v === "indexed" || v === "verified") ? "#0CCE6B" : (v === "unknown" ? "#9AA7B8" : "#FF4E42"); disp = v ? (v[0].toUpperCase() + v.slice(1)) : "\u2013"; }
    return '<div class="sb-score"><div class="sb-score-v" style="color:' + col + '">' + esc(disp) + '</div><div class="sb-score-l">' + esc(label) + '</div></div>';
  }

  function renderScores(b) {
    var host = q("scores"); if (!host) return;
    var s = (b && b.scores) || {}, v = (b && b.verification) || {};
    host.innerHTML =
      scoreCard("SEO", s.seo) + scoreCard(TR('public.g.pagespeed'), s.pagespeed) + scoreCard(TR('public.g.mobile'), s.mobile) +
      scoreCard(TR('public.g.accessibility'), s.accessibility) + scoreCard(TR('public.g.indexing'), s.indexing, true) +
      scoreCard(v.verified ? "Verified" : TR('public.g.verification'), v.status, true);
    var meta = q("meta");
    if (meta) meta.innerHTML = b && b.has_data
      ? "Last checked: " + (b.fetched_at ? new Date(b.fetched_at).toLocaleString() : "\u2013") + (b.fresh ? "" : ' \u00b7 <span class="sb-stale">stale, refresh recommended</span>')
      : 'No scores yet \u2014 click <b>'+TT('sb.js.refresh_scores')+'</b> to run PageSpeed Insights.';
    var reasons = q("reasons");
    if (reasons && v.reasons) reasons.innerHTML = v.reasons.map(function (r) { return '<li>' + esc(r) + '</li>'; }).join("");
  }

  function embedFor(embed) {
    if (!embed) return "";
    return SEL.method === "script" ? embed.script : SEL.method === "iframe" ? embed.iframe : embed.img;
  }
  function preview() {
    if (!site()) return;
    var u = "/plugin/public-seo-badge/preview?site=" + encodeURIComponent(site()) + "&type=" + SEL.type + "&theme=" + SEL.theme + "&size=" + SEL.size + "&ribbon=auto";
    GS.api(u).then(function (r) {
      var d = r && r.data; if (!d) return;
      var host = q("preview"); if (host) host.innerHTML = d.svg || "";
      var code = q("embed-code"); if (code) code.value = embedFor(d.embed);
      var url = q("public-url"); if (url) url.textContent = (d.embed && d.embed.url) || "";
    });
  }
  function load() {
    if (!site()) return;
    GS.api("/plugin/public-seo-badge/badge?site=" + encodeURIComponent(site())).then(function (r) {
      var b = r && r.data; renderScores(b);
      if (b && b.fetched_at) window.__sb_last_at = b.fetched_at;   // poll baseline
      if (b && b.config) {
        SEL.type = b.config.type || SEL.type; SEL.theme = b.config.theme || SEL.theme; SEL.size = b.config.size || SEL.size;
        syncControls();
        /* Restore the Verification-rules fields so saved values show AND aren't clobbered when a
           type/theme/size click next calls saveConfig(). */
        var mi = q("set-minseo"); if (mi) mi.value = (b.config.min_seo != null ? b.config.min_seo : 0);
        var ix = q("set-indexed"); if (ix) ix.checked = !!b.config.require_indexed;
      }
      preview();
    });
  }
  function syncControls() {
    ["type", "theme", "size", "method"].forEach(function (grp) {
      document.querySelectorAll('[data-sb-opt="' + grp + '"]').forEach(function (b) {
        b.classList.toggle("active", b.getAttribute("data-val") === SEL[grp]);
      });
    });
  }

  function refresh(btn) {
    if (!site()) return;
    var prevAt = window.__sb_last_at || null;
    var startT = Date.now();
    // Persistent progress toast so a 20-60s PageSpeed run shows LIVE feedback, not a blind wait.
    var pt = (window.GSUI && GSUI.progressToast)
      ? GSUI.progressToast(TT('sb.js.running_pagespeed') || 'Running PageSpeed Insights…')
      : { update:function(){}, done:function(){}, close:function(){} };
    if (btn) { btn.disabled = true; btn.dataset.t = btn.textContent; btn.textContent = TT('sb.a.refreshing_u2026'); }
    function done(msg, isErr) {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.t || "Refresh scores"; }
      if (msg) { var m = q("meta"); if (m) m.innerHTML = '<span class="' + (isErr ? "sb-stale" : "sb-mut") + '">' + esc(msg) + '</span>'; }
      // close the progress toast with a clear success/error line
      if (isErr) pt.done(msg || (TT('sb.js.check_failed') || 'PageSpeed check failed'), 'error');
      else pt.done(TT('sb.js.scores_ready') || 'Scores updated', 'success');
    }
    GS.api("/plugin/public-seo-badge/refresh?site=" + encodeURIComponent(site()), { method: "POST", body: "{}" }).then(function (r) {
      if (!(r && r.ok)) { done(TR('public.p.couldn_u2019t_start_the_refresh_plea'), true); return; }
      var d = r.data || {};
      if (d.queued) { pt.update(TT('sb.js.running_pagespeed') || 'Running PageSpeed Insights…', 10); pollBadge(prevAt, done, pt, startT); return; }
      if (d.ok && d.scores) { renderScores(d); preview(); done(""); return; }
      done(TR('public.p.couldn_u2019t_fetch_scores') + esc(d.detail || d.error || "unknown error") + (d.url ? " \u2014 tested " + esc(d.url) : ""), true);
    });
  }

  function pollBadge(prevAt, done, pt, startT) {
    pt = pt || { update:function(){}, done:function(){} };
    var n = 0;
    (function tick() {
      n++;
      // live progress: elapsed seconds + a bar that eases toward ~90% over the expected window
      var secs = startT ? Math.round((Date.now() - startT) / 1000) : 0;
      var pct = Math.min(90, 10 + (n / POLL.max) * 80);
      pt.update((TT('sb.js.running_pagespeed') || 'Running PageSpeed Insights…') + ' (' + secs + 's)', pct);
      GS.api("/plugin/public-seo-badge/badge?site=" + encodeURIComponent(site())).then(function (r) {
        var b = (r && r.data) || {};
        var at = b.fetched_at || null;
        if (at && at !== prevAt) { window.__sb_last_at = at; renderScores(b); preview(); done(""); return; }
        if (b.refreshing === false) { done(TR('public.p.couldn_u2019t_fetch_scores') + esc(b.last_error || TR('public.f3.pagespeed_didn_u2019t_return_score')), true); return; }
        if (n >= POLL.max) { done(TR('public.f3.still_running_u2026_scores_will_ap'), false); return; }
        setTimeout(tick, POLL.interval);
      }).catch(function () {
        if (n >= POLL.max) { done(TR('public.g.refresh_status_unavailable'), true); return; }
        setTimeout(tick, POLL.interval);
      });
    })();
  }
  function saveConfig() {
    var mi = q("set-minseo"), ix = q("set-indexed");
    GS.api("/plugin/public-seo-badge/save-settings?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify({
      type: SEL.type, theme: SEL.theme, size: SEL.size,
      min_seo: +((mi || {}).value || 0), require_indexed: !!((ix || {}).checked), ribbon: "auto"
    }) }).then(function (r) {
      var n = q("save-note");
      var saved = !!(r && r.ok && r.data && r.data.ok !== false);
      /* Reflect the PERSISTED config back into the fields so the user sees exactly what was stored. */
      if (saved && r.data && r.data.config) {
        if (mi && r.data.config.min_seo != null) mi.value = r.data.config.min_seo;
        if (ix) ix.checked = !!r.data.config.require_indexed;
      }
      if (n) { n.hidden = false; n.textContent = saved ? "Saved." : TR('public.g.save_failed_u2014_not_persisted'); setTimeout(function () { n.hidden = true; }, 2000); }
    });
  }

  document.addEventListener("click", function (e) {
    var opt = e.target.closest ? e.target.closest("[data-sb-opt]") : null;
    if (opt) { SEL[opt.getAttribute("data-sb-opt")] = opt.getAttribute("data-val"); syncControls();
      if (opt.getAttribute("data-sb-opt") === "method") { preview(); } else preview();
      if (["type","theme","size"].indexOf(opt.getAttribute("data-sb-opt")) >= 0) saveConfig(); return; }
    var rb = e.target.closest ? e.target.closest('[data-sb="refresh"]') : null; if (rb) { refresh(rb); return; }
    var cp = e.target.closest ? e.target.closest('[data-sb="copy"]') : null;
    if (cp) { var ta = q("embed-code"); if (ta) { ta.select(); try { document.execCommand("copy"); } catch (_) {} cp.textContent = TT('sb.a.copied'); setTimeout(function () { cp.textContent = TT('sb.a.copy_embed_code'); }, 1200); } return; }
    var sv = e.target.closest ? e.target.closest('[data-sb="save-settings"]') : null; if (sv) { e.preventDefault(); saveConfig(); }
  });
  document.addEventListener("gs:ready", load);
  document.addEventListener("gs:site-change", load);
  if (window.GS && GS.site) load();

  try { window.__sb_test = { refresh: refresh, pollBadge: pollBadge, renderScores: renderScores, load: load, saveConfig: saveConfig, POLL: POLL }; } catch (e) {}
})();

/* ---- admin: PageSpeed Insights API key (saved via this plugin's own admin-gated endpoint) ---- */
(function () {
  function q(k) { return document.querySelector('[data-sb="' + k + '"]'); }
  function site() { return (window.GS && GS.site) || ""; }
  function loadPsi() {
    if (!(window.GS && GS.user && GS.user.role === "admin")) return;
    GS.api("/plugin/public-seo-badge/psikey?site=" + encodeURIComponent(site())).then(function (r) {
      if (!(r && r.ok && r.data && r.data.ok)) return;
      var st = q("psi-status"); if (st) st.textContent = r.data.key_set ? ("Key set: " + r.data.key_masked) : TR('public.f3.no_key_set_requests_are_rate_limit');
    });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest('[data-sb="save-psi"]') : null; if (!b) return;
    e.preventDefault();
    var inp = q("psi-key"), st = q("psi-status"); if (st) st.textContent = TT('sb.a.saving');
    GS.api("/plugin/public-seo-badge/save-psikey?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify({ psi_key: (inp && inp.value) || "" }) }).then(function (r) {
      var ok = r && r.ok && r.data && r.data.ok;
      if (st) st.textContent = ok ? (r.data.key_set ? "Key saved." : TR('public.g.key_cleared')) : TR('public.g.save_failed_admin_only');
      if (inp && ok) inp.value = "";
    });
  });
  document.addEventListener("gs:ready", loadPsi);
})();
